import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useAccountCommunicationHandlers } from "../../../hooks";
import { BottomNavigationMobileMyBetsCountWrapper } from "./BottomBarNavigationWrapper";
import { HeaderActionCreators } from "../../../redux/action-creators";
import {
  HeaderSelectors,
  UserContextSelectors
} from "../../../redux/selectors";

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const MyBetsBottomBarNavigationItem = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const betsCount = useSelector(HeaderSelectors.betsCount);

  const { openLogin } = useAccountCommunicationHandlers();

  const onMyBetsClick = () => {
    if (isAuthenticated) {
      dispatch(HeaderActionCreators.openMyBets());
    } else openLogin();
  };

  return (
    <BottomBarNavigationItem
      onClick={onMyBetsClick}
      iconColor={"white"}
      iconLabel={"confirmed"}
      dataTestId={"bottom-navigation-mybets"}
      googleAnalyticsLabel={"bottom-navigation-mybets"}
    >
      <BottomNavigationMobileMyBetsCountWrapper>
        {betsCount !== null && betsCount !== undefined
          ? clamp(betsCount, 0, 99)
          : 0}
      </BottomNavigationMobileMyBetsCountWrapper>
      <FormattedMessage {...LocalizationMessages.bottomNavigationMyBets} />
    </BottomBarNavigationItem>
  );
};

export default React.memo(MyBetsBottomBarNavigationItem);

MyBetsBottomBarNavigationItem.propTypes = {};
